function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.427 4.488l.292.929.292.928H8.91l-.73.62-.73.618.292.929.292.928-.73-.464-.877-.619-.876.62-.73.463.291-.928.292-.929-.73-.619-.73-.619h1.899l.292-.928.292-.929zm0-4.488L4.82 4.798 0 4.952l3.798 3.096L2.483 13l3.944-2.786L10.371 13 9.202 8.048 13 4.952l-4.82-.154L6.427 0z",
  fill: "#E5A837",
  fillRule: "nonzero"
})));